<template>
<form>
    <div id="app" :class="isIframeRendering" v-if="!errorFound">
        <the-header />        
        <div v-show="!this.$store.state.inTranslation">
            <base-alert></base-alert>
            <the-container-sso />
            <small class="d-block  text-center">{{$t("or")}}</small>
            <hr />
            <the-container-login />
            <the-container-pwa />
            <hr />
            <the-container-signup v-if="this.$store.state.userSign" />
        </div>
        <div class="spinner spinner-page text-warning" v-show="this.$store.state.inTranslation"></div>
    </div>
    <page-notfound v-else />
</form>
</template>

<script>    
    import TheContainerSSO from './components/containers/TheContainerSSO';
    import TheContainerLogin from './components/containers/TheContainerLogin';
    import TheContainerSignup from './components/containers/TheContainerSignup';
    import TheContainerPWA from './components/containers/TheContainerPWA';
    import TheHeader from './components/containers/TheHeader';
    import BaseAlert from './components/bases/BaseAlert';

    import PageNotFound from './components/templates/PageNotFound'

    import SharedMixin from './mixins/SharedMethods.js';    

    export default {
        name: 'App',        
        components: {            
            'the-container-sso' : TheContainerSSO,
            'the-container-login' : TheContainerLogin,
            'the-container-signup' : TheContainerSignup,
            'the-container-pwa' : TheContainerPWA,
            'the-header': TheHeader,
            'base-alert': BaseAlert,
            'page-notfound' : PageNotFound             
        },
        data() {
            return {
                errorFound: false
            }
        },
        computed: {
            isIframeRendering: function () {
                try {
                    let isIframeRender = !(window===window.parent)
                    return {
                        'box p-5 embedFrame' : isIframeRender,
                        'box p-5' : !isIframeRender
                    }
                } catch (e) {
                    return {
                        'box p-5 embedFrame' : true 
                    }
                }            
            }
        },
        mounted() {
            try {
                this.isMainLoading = true;
                this.startup();
            } catch (e) {
                console.log(e);
                this.errorFound = true;
                this.isMainLoading = false;
            }
        },
        mixins: [SharedMixin],
        methods: {
            loadUrlParameters: function () {
                let url_string = window.location.href;
                let url = new URL(url_string);
                let queryString = url.searchParams.get("c");                
                if (!queryString) {
                    console.log("Problema para localizar os parametros de carregamento.");
                    this.errorFound = true;
                    return false;
                }
                var result = JSON.parse(atob(queryString));                
                return result;

            },

            loadBPMSParameters: function (origin, language) {
                let self = this;                
                this.$http.get(`parameters?origin=${origin}&lang=${language}`)
                    .then(response => {                        
                        let bpmsParameters = response.data;
                        self.setUserSign(bpmsParameters.useSignIn);
                        self.setAllowedLanguages(bpmsParameters.allowedLanguages)                                                
                        self.setOrquestraBootstrapCDN(bpmsParameters.orquestraBootstrapCDN);
                        self.setLogo(bpmsParameters.logo);
                        self.setSkinFile(bpmsParameters.skinFile);
                        self.setGlobalJsCss(bpmsParameters.globalJsCss);
                        self.setIsSaml(bpmsParameters.isSaml);
                        self.setSamlIssuer(bpmsParameters.samlIssuer);
                        self.setSamlMetadata(bpmsParameters.samlMetadata);
                    }, error => {
                        console.log(error);
                        return null;
                    });
            },

            startup: function () {                
                let urlParameters = this.loadUrlParameters();
                if (!urlParameters || !urlParameters.origin) {
                    //Redirecionar para Pagina de erro
                    console.log("Problema para identificar a origem do seu Orquestra BPMS.");                    
                    return false;
                }
                if (!urlParameters.codSystem)
                    urlParameters.codSystem = 5;                

                this.loadBPMSParameters(urlParameters.origin, urlParameters.language);
                
                this.setIntegrationName("GATEWAY->BPMS");
                this.setOrigin(urlParameters.origin);
                this.setAppCode(urlParameters.appCode);
                this.setLanguage(urlParameters.language);
                this.setUrlRedirect(urlParameters.urlRedirect); 
                this.setCodSystem(urlParameters.codSystem);
            },
            setIsSaml: function (isSaml) {
                this.$store.commit('CHANGE_SAML', isSaml);
            },
            setSamlIssuer: function (samlIssuer) {
                this.$store.commit('CHANGE_SAML_ISSUER', samlIssuer);
            },
            setSamlMetadata: function (samlMetadata) {
                this.$store.commit('CHANGE_SAML_METADATA', samlMetadata);
            },
            setCodSystem: function (codSystem) {
                this.$store.commit('CHANGE_CODSYSTEM', codSystem);
            },
            setLanguage: function (languageSelected) {
                this.$i18n.locale = languageSelected;
                this.$store.commit("CHANGE_LOCALIZATION", languageSelected);
            },

            setOrigin: function (origin) {
                this.$store.commit("CHANGE_ORIGIN", origin);
            },

            setIntegrationName: function (integrationName) {
                this.$store.commit("CHANGE_INTEGRATION_NAME", integrationName);
            },

            setAppCode: function (appCode) {
                if (appCode)
                    this.$store.commit("CHANGE_APP_CODE", appCode);
            },

            setUserSign: function (userSign) {
                this.$store.commit("CHANGE_USER_SIGN", (userSign === 'true'));
            },

            setUrlRedirect: function (urlRedirect) {
                this.$store.commit("CHANGE_URL_REDIRECT", urlRedirect);
            },

            setAllowedLanguages: function (allowedLanguages) {                
                var languages = allowedLanguages.split(",");                   
                languages.forEach(element => {
                    var language = element;
                    language = language.trim();
                    language = language.toUpperCase();

                    switch (language) {
                        case 'PT-BR':
                            this.$store.commit("CHANGE_ACTIVE_BR", true);
                            break;
                        case 'EN-US':
                            this.$store.commit("CHANGE_ACTIVE_US", true);
                            break;
                        case 'ES-ES':
                            this.$store.commit("CHANGE_ACTIVE_ES", true);
                            break;
                    }

                });               
            },

            setOrquestraBootstrapCDN: function (orquestraBootstrapCDN) {
                let isURL = new RegExp('^(?:[a-z]+:)?//', 'i');
                if (isURL.test(orquestraBootstrapCDN)) {
                    this.$store.commit("CHANGE_ORQUESTRA_BOOTSTRAP_CDN", orquestraBootstrapCDN);
                } else {
                    this.$store.commit("CHANGE_ORQUESTRA_BOOTSTRAP_CDN", this.$store.state.origin + orquestraBootstrapCDN);
                }
            },

            setLogo: function (logo) {
                if (logo) {
                    let isURL = new RegExp('^(?:[a-z]+:)?//', 'i');
                    const isContent = logo.toLowerCase().includes(';base64');
                    if (isURL.test(logo) || isContent) {
                        this.$store.commit("CHANGE_LOGO_URL", logo);
                    } else {
                        this.$store.commit("CHANGE_LOGO_URL", this.$store.state.orquestraBootstrapCDN + logo.replace("../common/plugin/orquestra-bootstrap/dist", ""));
                    }
                } else {
                    if (this.$store.state.systemTitle.toLowerCase().includes("zeev")) {
                        var urlResult = `${this.$store.state.orquestraBootstrapCDN}/assets/logos/zeev/zeev-h.png`
                        this.$store.commit("CHANGE_LOGO_URL", urlResult)
                    } else {
                        let urlResult = `${this.$store.state.orquestraBootstrapCDN}/assets/logos/bpms/bpms.png`
                        this.$store.commit("CHANGE_LOGO_URL", urlResult)
                    }
                }
            },

            setSkinFile: function (skinFile) {
                if (skinFile) {
                    this.$store.commit("SKIN_FILE", skinFile);
                }
            },

            setGlobalJsCss: function (globalJsCss) {
                if (globalJsCss) {
                    this.$store.commit("GLOBAL_JS_CSS", globalJsCss);
                }

                this.addGlobalJsCss();
            },

            addGlobalJsCss: function () {
                var globalJsCss = this.$store.state.globalJsCss;

                var tagMatches = this.getJsCssTagMatches(globalJsCss, 'link', `<link(?<attributes>[^>]*)?>`);
                tagMatches = tagMatches.concat(this.getJsCssTagMatches(globalJsCss, 'style', `(<style(?<attributes>[^>]*)?>)(?<content>((?!<\/style>)[\\s\\S])*)(<\/style>)`));//eslint-disable-line

                tagMatches = tagMatches.sort((a, b) => a.index - b.index);

                for (var tagMatch of tagMatches) {
                    var tag = this.addElementToBody(tagMatch.tagType, tagMatch.match.groups.content);

                    var attributes = tagMatch.match.groups.attributes;
                    if (!attributes)
                        continue;

                    var attributesListMatches = attributes.matchAll(new RegExp(`(?<attributeName>[^=]*)=(?<quotes>["'])(?<attributeValue>((?!(\\k<quotes>)).)*)(\\k<quotes>)`, 'g'));
                    for (var attributesListMatch of attributesListMatches)
                        tag.setAttribute(attributesListMatch.groups.attributeName.trim(), attributesListMatch.groups.attributeValue);
                }
            },

            getJsCssTagMatches: function (globalJsCss, tagType, tagRegexSource) {
                var tagRegex = new RegExp(tagRegexSource, 'g');
                var tagMatches = globalJsCss.matchAll(tagRegex);

                var result = [];
                for (var tagMatch of tagMatches) {

                    result.push({
                        index: tagMatch.index,
                        tagType: tagType,
                        match: tagMatch
                    });

                }

                return result;
            }

        }
    }
</script>

<style>
    #app {
        margin: 0 auto;
        width: 50%;
        min-height: 100%;
        background-color: white;
        padding: 1px;
        max-width: 500px;
    }
    .embedFrame{
        margin: 0 auto;
        width: 100% !important;   
        min-height: 100vh;                
        max-width: 800px !important;
    }
    #main-loading {     
        margin: 0;        
        position: absolute;
        top: 50%;
        left: 50%;
        margin-right: -50%;
    }
    .spinner-page {
        left: 50%;        
        position: relative;       
        margin-top : 50%;
    }   
</style>